import { useGlobalBillClient } from '~/hooks/useGlobalBillClient';
export const useBillClient = (clientId)=>{
    const { openGlobalBillModalForClient } = useGlobalBillClient();
    return ()=>openGlobalBillModalForClient(clientId);
};
